<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion-carta' }">{{
                $t("configuracionCarta")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("ProgramacionCarta") }}
            </li>
          </ol>
        </nav>
      </div>
      <!-- <CabeceraInformes
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :idTpv="this.idTpv"
                :listTpv="listTpv"
                :dateto="dateto"
                :datefrom="datefrom"
                id="cabecera"
                :conTodos="true"
            /> -->

      <!-- <CabeceraInformes
                :idBusiness="idBusiness"
                :listBusinesses="listBusinesses"
                :dateto="dateto"
                :datefrom="datefrom"
                id="cabecera"
                :conTodos="false"

            /> -->
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="listBusiness"
                  ><strong>{{ $t("negocio") }}</strong></label
                >

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="emitirConsulta()"
                  :placeholder="$t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.establishmentName"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fecha") }}</label>
                <datetime
                  :value-zone="timezoneId"
                  :auto="true"
                  class="theme-numier"
                  format="dd-MM-yyyy"
                  :title="$t('fecha')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="datefrom"
                ></datetime>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaFin") }}</label>
                <datetime
                  :auto="true"
                  class="theme-numier"
                  :value-zone="timezoneId"
                  :title="$t('fechaFin')"
                  format="dd-MM-yyyy"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="dateto"
                ></datetime>
              </div>
            </div>
            <div class="btn-group col-md-5">
              <div>
                <label>&nbsp;</label>
                <div class="form-group">
                  <button class="btn btn-primary" @click="emitirConsulta()">
                    <!-- <img
                      src="static/img/sync.gif"
                      alt=""
                      v-if="loading"
                      width="15"
                    /> -->
                    {{ $t("consultar") }}
                  </button>
                </div>
              </div>
              <div class="col-md">
                <label>&nbsp;</label>
                <div class="form-group"></div>
              </div>
              <div class="col-md">
                <label>&nbsp;</label>
                <div class="form-group"></div>
              </div>
            </div>
            <div class="col-md-5">
              <label
                ><strong>{{ $t("estado") }}</strong></label
              >
              <div class="form-group">
                <el-radio
                  @change="emitirConsulta()"
                  v-model="buscarEstado"
                  :label="2"
                >
                  {{ $t("todos") }}
                </el-radio>
                <el-radio
                  @change="emitirConsulta()"
                  v-model="buscarEstado"
                  :label="0"
                >
                  Sin publicar
                </el-radio>
                <el-radio
                  @change="emitirConsulta()"
                  v-model="buscarEstado"
                  :label="1"
                >
                  Publicado
                </el-radio>
                <template v-if="tienePermisos">
                  <VueToggles
                      id="switchConfigProgramacion"
                    @click="
                      openModalConfigProgramacion(programacionActivada)
                    "
                    :value="programacionActivada"
                    height="35"
                    width="250"
                    fontSize="14"
                    fontWeight="bold"
                    :checkedText="'Planificaciones activadas'"
                    :uncheckedText="'Planificaciones desactivadas'"
                    checkedBg="#28a745"
                    uncheckedBg="lightgrey"
                  ></VueToggles>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="tienePermisos">
        <div class="table-responsive">
          <template>
          
            <div class="col-md-12">
              <div class="card">
                <div class="col-md-2">
                  <div class="form-group">
                    <router-link
                      :to="{
                        name: 'planificacion-carta',
                        params: {
                          idBusiness: idBusiness,
                          modo: 0,
                        },
                      }"
                    >
                      <button class="btn btn-primary"><i class="fa fa-plus-square"></i>
                          {{ $t("nueva") }} planificación
                      </button>
                    </router-link>
                  </div>
                </div>
                <table class="table table-bordered table-striped text-nowrap" v-if="respuesta">
                  <thead class="thead-dark">
                    <tr style="cursor: pointer">
                      <th
                        v-if="ordenarAlias === 0"
                        @click="sortedArrayAliasASC('alias')"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("alias") }}
                      </th>
                      <th
                        v-else
                        @click="sortedArrayAliasDESC('alias')"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("alias") }}
                      </th>
                      <th
                        v-if="ordenarFechaI === 0"
                        @click="sortedArrayFechaIASC('fechaInicio')"
                      >
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("fecha") }}
                      </th>
                      <th v-else @click="sortedArrayFechaIDESC('fechaInicio')">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("fecha") }}
                      </th>
                      <th><i style="color: white"></i>{{ $t("estado") }}</th>
                      <th v-if="ordenarFechaP === 0" @click="sortedArrayFechaPASC('fechaInicio')">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("fecha") }} {{ $t("dePublicacion") }}
                      </th>
                      <th v-else @click="sortedArrayFechaPDESC('fechaInicio')">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        {{ $t("fecha") }} {{ $t("dePublicacion") }}
                      </th>
                      <th v-if="ordenarCantidadProductos === 0" @click="sortedArrayCantidadProductosASC('fechaInicio')">
                        <i style="color: white" class="fa fa-angle-up"></i>
                        Nº DE PRODUCTOS
                      </th>
                      <th v-else @click="sortedArrayCantidadProductosDESC('fechaInicio')">
                        <i style="color: white" class="fa fa-angle-down"></i>
                        Nº DE PRODUCTOS
                      </th>
                      <th>{{ $t("acciones") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="obj in list">
                      <td>{{ obj.Alias }}</td>
                      <td class="text-center">{{ obj.fechaInicio  | parseDateDia }}</td>
                      <td v-if="!obj.isPublicado" class="text-center">
                        <span class="text-danger">Sin publicar</span>
                      </td>
                      <td v-else class="text-center">
                        <span class="text-success">{{ $t("Publicado") }}</span>
                      </td>
                      <td v-if="!obj.isPublicado" class="text-center">-</td>
                      <td v-else class="text-center">
                        {{ obj.fechaPublicacion | parseDateMinSlash}}
                      </td>
                      <td align="center">
                        <span :class="obj.cantidadProductos == 0 ? 'text-danger' : ''">{{ obj.cantidadProductos }} 
                          <i v-if="obj.cantidadProductos == 0" class="fa-solid fa-triangle-exclamation" v-tooltip.top-center="
                            'Esta planificación no aparecerá en la carta reflejada puesto que no tiene productos asignados'
                          ">
                          </i></span>
                      </td>
                      <td align="center">
                        <router-link
                          
                          :to="{
                            name: 'planificacion-carta',
                            params: {
                              CartaProgramada: obj,
                              idBusiness: idBusiness,
                              idTpv: idTpvAMandar,
                              modo: 1,
                            },
                          }"
                          class="btn btn-primary btn-link"
                        >
                          <i style="color: orange" v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt"></i>
                        </router-link>
                        <!--<button
                          v-if="obj.isPublicado == 0"
                          type="button"
                          class="btn btn-primary btn-sm"
                          style="margin-left: 10px"
                          @click="cambiarEstadoS(1, obj)"
                        >
                          {{ $t("publicar") }}
                        </button>
                        <button
                          v-else
                          type="button"
                          class="btn btn-danger btn-sm"
                          style="margin-left: 10px"
                          @click="cambiarEstadoS(0, obj)"
                        >
                          {{ $t("Ocultar") }}
                        </button>-->
                        <!--<button
                          type="button"
                          class="btn btn-primary btn-sm"
                          style="margin-left: 10px"
                          @click="cambiarEstadoS(!obj.isPublicado, obj)"
                        >-->


                          <i :class="obj.isPublicado ? 'fa-solid fa-eye-slash text-primary' : 'fa-solid fa-eye text-primary'" @click="cambiarEstadoS(obj.isPublicado, obj)"></i>
                          <i :class="'fa-solid fa-trash-can text-danger pl-3'" @click="eliminarProgramacion(obj)"></i>
                        <!--</button>-->
                        <!--<div class="btn btn-danger btn-link btn-xs">
                          <el-checkbox @change="cambiarEstadoS(obj.id, obj.isPublicado)" v-model="obj.isPublicado">
                            <template></template>
                            <strong>{{
                                obj.isPublicado
                                  ? 'Ocultar'
                                  : 'Publicar'
                            }}
                            </strong>
                          </el-checkbox>
                        </div>-->
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="alert alert-danger" role="alert">
                  {{ $t("noHay") }} <strong>planificaciones</strong>
                  {{ $t("rangoDeFechas") }}
                </div>
              </div>

              </div>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="col-md-12">
          <div class=" alert alert-primary" align="center">
            <h3>
              <i class="fas fa-exclamation-circle"></i>
              {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
            </h3>

            <span>
              {{ $t("paraMasInformacionContacteConSu") }}
              <strong>{{ $t("distribuidor") }}</strong
              >.</span
            >
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  LoadingButton,
  Radio,
  CheckboxGroup,
  Checkbox,
  Loading,
} from "element-ui";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import swal from "sweetalert2";
import moment from "moment";

export default {
  created() {
    this.dateto.setDate(new Date().getDate() + 7);
    this.dateto = this.dateto.toISOString();
    this.datefrom = this.getMonday(this.datefrom).toISOString();

    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("ProgramacionCarta"));
    this.getBusiness();

    // console.log("fdndfjgnzdfjsdnfjgndhj")
    /*if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }*/

    //this.emitirConsulta();
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date().toISOString(),
      
      dateto: new Date(),
      listBusinesses: [],
      idBusiness: 0,
      list: [],
      mode: 0,
      objectChart: null,
      contador: 0,
      listTpv: [],
      idTpv: -1,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },

      ordenarFechaI: 0,
      ordenarFechaF: 0,
      ordenarFechaP: 0,
      ordenarAlias: 0,
      ordenarCantidadProductos: 0,
      idTpvAMandar: " ",
      guardado: 0,
      publi: 0,
      publicado: 0,
      buscarEstado: 2,
      respuesta: false,
      tienePermisos: true,
      programacionActivada: false
    };
  },
  computed: {
    timezoneId() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    /* urlExportPDF() {
                // return "../api/public/index.php/workers/exportVentasWorkers/PDF?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
                
                let idTpvAMandar = "";

                if (this.idTpv == -1) {
                    idTpvAMandar = 0;
                } else {
                    idTpvAMandar = this.idTpv;
                }

                return this.$store.getters.apiUrl + "/workers/exportAperturasWorkers/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


            },
            urlExportExcel() {
                let idTpvAMandar = "";

                if (this.idTpv == -1) {
                    idTpvAMandar = 0;
                } else {
                    idTpvAMandar = this.idTpv;
                }

                return this.$store.getters.apiUrl + "/workers/exportAperturasWorkers/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


            },*/
  },
  methods: {
     getConfigTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 106,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.programacionActivada = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    openModalConfigProgramacion(valor) {
      if (valor) {
        swal({
          title: '¿Estás seguro de querer desactivar la planificación de la carta?',
          text: 'Al desactivarla, no se podrán realizar pedidos para el resto de la semana y la selección de productos será la misma todos los días.',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: 'Sí, desactivar la planificación',
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.cambiarConfiguracion(valor);
          }
        });
      } else {
        swal({
          title: '¿Estás seguro de querer activar la planificación de la carta?',
          text: 'Al activarla, se podrán realizar pedidos para el resto de la semana y la selección de productos variará en función de las programaciones creadas.',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: 'Sí, activar la planificación',
          cancelButtonText: this.$t("cancelar"),
          buttonsStyling: true,
        }).then((result) => {
          if (result.value) {
            this.cambiarConfiguracion(valor);
          }
        });
      }
    },
    cambiarConfiguracion(valor){
      this.programacionActivada = valor ? false : true;

      this.loading = Loading.service({ text: "Cargando..." });
      
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
        valor: this.programacionActivada,
      };

      let vm = this;
      let controller = "configurarProgramacionCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("servicioActualizadoCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }

          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    getMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
          diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    },

    emitirConsulta() {
      this.loading = Loading.service({ text: "Cargando..." });
      this.checkPermisos();
    },

    cambioTpv(idTpvData, filtrar) {
      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
      }

      this.idTpv = idTpvData;
      this.emitirConsulta();
    },

    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },
    sortedArrayAliasASC: function () {
      this.ordenarAlias = 1;

      function compare(a, b) {
        if (a.fechaInicio < b.fechaInicio) return -1;
        if (a.fechaInicio > b.fechaInicio) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayAliasDESC: function () {
      this.ordenarAlias = 0;

      function compare(a, b) {
        if (a.fechaInicio > b.fechaInicio) return -1;
        if (a.fechaInicio < b.fechaInicio) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayCantidadProductosASC: function () {
      this.ordenarCantidadProductos = 1;

      function compare(a, b) {
        if (a.cantidadProductos < b.cantidadProductos) return -1;
        if (a.cantidadProductos > b.cantidadProductos) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayCantidadProductosDESC: function () {
      this.ordenarCantidadProductos = 0;

      function compare(a, b) {
        if (a.cantidadProductos > b.cantidadProductos) return -1;
        if (a.cantidadProductos < b.cantidadProductos) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayFechaIASC: function () {
      this.ordenarFechaI = 1;

      function compare(a, b) {
        if (a.fechaInicio < b.fechaInicio) return -1;
        if (a.fechaInicio > b.fechaInicio) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayFechaIDESC: function () {
      this.ordenarFechaI = 0;

      function compare(a, b) {
        if (a.fechaInicio > b.fechaInicio) return -1;
        if (a.fechaInicio < b.fechaInicio) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayFechaFASC: function () {
      this.ordenarFechaF = 1;

      function compare(a, b) {

        if (a.fechaFin < b.fechaFin) return -1;
        if (a.fechaFin > b.fechaFin) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayFechaFDESC: function () {
      this.ordenarFechaF = 0;

      function compare(a, b) {
        if (a.fechaFin > $b.fechaFin) return -1;
        if (a.fechaFin < $b.fechaFin) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayFechaPASC: function () {
      this.ordenarFechaP = 1;

      function compare(a, b) {

        if (a.fechaPublicacion != 0 && b.fechaPublicacion != 0) {
          if (a.fechaPublicacion < b.fechaPublicacion) return -1;
          if (a.fechaPublicacion > b.fechaPublicacion) return 1;
          return 0;
        } else {
          return 1;
        }
      }

      return this.list.sort(compare);
    },
    sortedArrayFechaPDESC: function () {
      this.ordenarFechaP = 0;

      function compare(a, b) {
        if (a.fechaPublicacion != 0 && b.fechaPublicacion != 0) {
          if (a.fechaPublicacion > b.fechaPublicacion) return -1;
          if (a.fechaPublicacion < b.fechaPublicacion) return 1;
        } else {
          return -1;
        }
        return 0;
      }

      return this.list.sort(compare);
    },
     checkPermisos() {
      let vm = this;

      var config = {
        params: {

          jwt: this.$store.getters.jwt,
          idBusiness: this.idBusiness,
          numConfig: 108
        },

        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkConfigByBusiness", config)
        .then(function (response) {

          if (response.data.result) {
            vm.tienePermisos = true;
            vm.getConfigTpv();
            vm.getCartasProgramadas();
          } else {
            vm.tienePermisos = false;
            swal({
              title: vm.$t("atencion"),
              text: 'Este negocio no tiene acceso a este módulo',
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.loading.close();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.checkPermisos();
          vm.getConfigTpv();
          // vm.getSalesOperarios();

          
          //   vm.getTpv();
          // console.log("sdfsdfsdfsdfsdfsd");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function (response) {
          if (response.data.response) {
            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            vm.listCheckBoxTpv = response.data.result;

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCartasProgramadas() {
      this.list = [];
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        this.loading.close();
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

          this.loading.close();
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          if (this.idTpv == -1) {
            this.idTpvAMandar = 0;
          } else {
            this.idTpvAMandar = this.idTpv;
          }

          var config = {
            params: {
              idBusiness: this.idBusiness,
              datefrom: moment(this.datefrom).startOf("day").unix(),
              dateto: moment(this.dateto).endOf("day").unix(),
              estado: this.buscarEstado,
              jwt: this.$store.getters.jwt,
              desde: 1,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(
              this.$store.getters.apiUrl + "delivery/getCartasProgramadas",
              config
            )
            .then(function (response) {
              if (response.data.response && response.data.result.length != 0) {
                vm.list = response.data.result;
                if (vm.list.length != 0) {
                  vm.respuesta = true;
                } else {
                  vm.respuesta = false;
                }
              } else if (response.data.response == false) {
                swal({
                  title: "Lo sentimos",
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info",
                });
                vm.respuesta = false;
              }/* else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }*/
              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    },
    eliminarProgramacion(obj){
      swal({
        title: "¿Estás seguro?",
        text: "Estás a punto de eliminar esta planificación.",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sí, estoy seguro",
        cancelButtonText: "Cancelar",
        type: "warning",
      }).then((result) => {

        if (result.value) {
          this.loading = Loading.service({ text: "Cargando..." });
          var config = {
            params: {
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };
          var params = {
            idCartaProgramada: obj.id,
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          };

          let vm = this;
          let controller = "eliminarCartaProgramada";
          this.axios
            .post(
              this.$store.getters.apiUrl + "delivery/" + controller,
              params,
              config
            )
            .then(function(response) {
              if (response.data.response) {
                vm.$notify({
                  message: "Planificación eliminada correctamente",
                  icon: "nc-icon nc-check-2",
                  timeout: 2000,
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "success",
                })

                //vm.loading = Loading.service({ text: "Cargando..." });
                vm.getCartasProgramadas();
              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.loading.close();
              }
            })
            .catch(function(error) {
              console.log(error);
              vm.inProgress = false;
            });
        }
        
      });
    },
    cambiarEstadoS(estado, obj) {
      let vm   = this;

      swal({
        title: "¿Estás seguro?",
        text: estado ? "Estás a punto de ocultar esta planificación." : "Estás a punto de publicar esta planificación.",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sí, estoy seguro",
        cancelButtonText: "Cancelar",
        type: "warning",
      }).then((result) => {
        if (result.value) {
          vm.loading = Loading.service({ text: "Cargando..." });
          vm.cambiarEstado(estado, obj)
        }
      });
    },
    cambiarEstado(estado, obj) {
      let vm = this;

      let status = true;

      if (estado) {
        status = false;
      }

     // console.log(status);
      var config = {
        params: {
          jwt: vm.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
          idBusiness: this.idBusiness,
          idCarta: obj.id,
          estado: status,
      }
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/updateEstadoCartasProgramadas",
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.getCartasProgramadas();
          }
        });
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
#switchConfigProgramacion {
  float: right;
  margin-left: 5px !important;
}
@media only screen and (max-width: 768px) {
  #switchConfigProgramacion {
    margin-top: 3% !important;
    float: left;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/PlanificacionCarta/PlanificadorCarta.vue